module.exports = __webpack_public_path__ + "media/images/post/icon_sns_fb-6ae7acd30b010ac7de53fe7bd2b26e12.png";